import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import componentStyles from "./video-carousel-item-component.scss";
import YoutubeVideoWithPosterComponent from "components/core/youtube-video-with-poster/youtube-video-with-poster-component";
import ColorfulTitleComponent from "/components/core/colorful-title/colorful-title-component";
import PictureComponent from "/components/core/picture/picture-component";
class VideoCarouselItemComponent extends PureComponent {
    onPlayButtonClicked() {
        const { onPlay, data } = this.props;
        onPlay(data.videoId, data.title);
    }
    render() {
        const { data, isMobile } = this.props;
        const screenRatios = {
            mobile: data.mobileImageWidthRatio
        };
        return /*#__PURE__*/ _jsxs("div", {
            className: `jsx-${componentStyles.__hash}` + " " + "video-carousel-item-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "video-part",
                    children: data.videoId && isMobile ? /*#__PURE__*/ _jsx("div", {
                        className: `jsx-${componentStyles.__hash}` + " " + "video-component-wrapper",
                        children: /*#__PURE__*/ _jsx(YoutubeVideoWithPosterComponent, {
                            videoId: data.videoId,
                            poster: data.poster,
                            muted: false,
                            volume: 100
                        })
                    }) : /*#__PURE__*/ _jsxs("div", {
                        onClick: this.onPlayButtonClicked,
                        className: `jsx-${componentStyles.__hash}` + " " + "poster-image-wrapper",
                        children: [
                            /*#__PURE__*/ _jsx(PictureComponent, {
                                pictureClass: "poster-image",
                                src: data.poster,
                                screenRatios: screenRatios
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: `jsx-${componentStyles.__hash}` + " " + "play-button-container",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: `jsx-${componentStyles.__hash}` + " " + "play-button"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(ColorfulTitleComponent, {
                    className: "video-title",
                    text: data.title
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.onPlayButtonClicked = this.onPlayButtonClicked.bind(this);
    }
}
export { VideoCarouselItemComponent as default };
